import { z } from 'zod';

import { getApiInstance, harden, Response, Cache } from '../core';

/**
 * @see {@link https://bitbucket.org/reachmedianetwork/player-api} for the original response object.
 */
const GetAcquireUrlHeadersDataSchema = z.object({
    /** The headers returned by the final response */
    headers: z.record(z.union([z.string(), z.array(z.string())])),
    /** The original URL */
    targetUrl: z.string(),
    /** The final URL after redirects */
    finalUrl: z.string(),
});

export async function getAcquireUrlHeaders(params: {
    /** The URL to retrieve the response headers from. */
    url: string;
}): Response<z.infer<typeof GetAcquireUrlHeadersDataSchema>> {
    const { api, cacheConfig } = await getApiInstance();
    const urlPath = 'acquireUrlHeaders';

    cacheConfig(Cache.GetWithFallback, urlPath);

    const response = await api.get(urlPath, {
        params,
    });

    return harden(GetAcquireUrlHeadersDataSchema, response.data);
}
